import MSWindow from "../../../../components/MSWindow/MSWindow";
import { useWindowManager } from "../../utils/WindowManager";
import { AnimatePresence } from "motion/react";

const HomeDesktop = () => {
  const { state, closeWindow } = useWindowManager();

  const handleCloseWindow = (id: string) => {
    closeWindow(id);
  };
  return (
    <AnimatePresence>
      {Array.from(state.windows.values()).map((window) => {
        return (
          <MSWindow
            key={window.id}
            id={window.id}
            windowTitle={window.windowTitle || ""}
            onCloseWindowClick={handleCloseWindow}
            initialPosition={window.position}
            zIndex={window.zIndex}
            isMinimized={window.isMinimized}
            isMaximized={window.isMaximized}
            icon={window.icon}
            showAddressBar={window.showAddressBar}
            addressBarLink={window.addressBarLink}
            showBottomBar={window.showBottomBar}
          >
            {typeof window.component === "function" ? (
              <window.component />
            ) : (
              window.component
            )}
          </MSWindow>
        );
      })}
    </AnimatePresence>
  );
};

export default HomeDesktop;
